// 奖励转换
ConvertRewardManager = xClass("ConvertRewardManager")

const ID_TO_KEY = {
    "55": "pet_story"
}
var instance = null;
ConvertRewardManager.getInstance = function () {
    if (!instance) {
        instance = ConvertRewardManager.new();
    }
    return instance
}
ConvertRewardManager.prototype.ctor = function () {
    this.activityConvertState = {
        "test": false,
        "pet_story": true,
    }
}

ConvertRewardManager.prototype.initActivityConvertState = function (state) {
    this.activityConvertState = state
    cc.log("[ConvertReward] initActivityConvertState ", this.activityConvertState)
}
ConvertRewardManager.prototype.updateActivityConvertState = function (key, value) {
    // cc.log("[ConvertReward] updateActivityConvertState key", key, value)
    if (this.activityConvertState[key] != null) {
        this.activityConvertState[key] = value
    }
    cc.log("[ConvertReward] updateActivityConvertState ", this.activityConvertState)
}

ConvertRewardManager.prototype.isConvertRewards = function (key) {
    return !this.activityConvertState[key]
}

ConvertRewardManager.prototype.getRule = function (key) {
    let config = MetaManager.getRewardConvertConfig()
    if (config[key]) {
        return config[key].rule
    }
    return false
    // return false
    // return "1-20|10011:1;21-60|10009:1;61-100|10006:1;101-999999|10002:1,14:10"
}
ConvertRewardManager.prototype.checkConvert = function (reward, skipCheck) {
    let key = ID_TO_KEY[reward.itemId]
    if (!key) return [reward]
    cc.log("[ConvertReward] checkConvert key", key, skipCheck)
    if (!skipCheck) {
        if (!this.isConvertRewards(key)) {
            return [reward]
        }
    }
    let rule = this.getRule(key)
    if (!rule) {
        cc.error("[ConvertReward] 缺少规则配置 key = ", key)
        return [reward]
    }
    let newRewards = []
    switch (key) {
        case "pet_story":
            newRewards = this.convert1(rule, reward)
            break;

        default:
            newRewards = [reward]
            break;
    }
    return newRewards
    // return [{
    //     itemId: 55,
    //     num: 10
    // }]
}
// let rule = "1-20|10011:1;21-60|10009:1;61-100|10006:1;101-999999|10002:1,14:10"
// 这是规则解析1 符合上面规则的可以直接传规则str进行转换解析 后续新增自行添加新的解析规则
ConvertRewardManager.prototype.convert1 = function (rule, reward) {
    let arr = rule.split(";")
    let rewardList = []
    for (let i = 0; i < arr.length; i++) {
        let arr1 = arr[i].split("|")
        let arr1_0 = arr1[0].split("-")
        if (i == arr.length - 1 || (reward.num >= Number(arr1_0[0]) && reward.num <= Number(arr1_0[1]))) {
            let arr1_1 = arr1[1].split(",")
            for (let j = 0; j < arr1_1.length; j++) {
                let arr1_1_a = arr1_1[j].split(":")
                rewardList.push({
                    itemId: arr1_1_a[0],
                    num: Number(arr1_1_a[1])
                })
            }
            break
        }

    }
    return rewardList
}
ConvertRewardManager.prototype.mergeReward = function (rewards, reawrd) {
    if (rewards.__isLuaTable) {
        for (let i = 1; i < $len(rewards); i++) {
            if (rewards[i].itemId == reawrd.itemId) {
                rewards[i].num = Number(rewards[i].num)
                rewards[i].num += Number(reawrd.num)
                return true
            }
        }
    } else {
        for (let i = 0; i < rewards.length; i++) {
            if (rewards[i].itemId == reawrd.itemId) {
                rewards[i].num = Number(rewards[i].num)
                rewards[i].num += Number(reawrd.num)
                return true
            }
        }
    }
    return false
}
// 转换奖励
ConvertRewardManager.prototype.convertRewards = function (rewards, skipCheck) {
    let newRewards = null
    try {
        if (rewards.__isLuaTable) {
            newRewards = table()
            for (let i = 1; i <= $len(rewards); i++) {
                let arr = this.checkConvert(clone(rewards[i]), skipCheck)
                for (let j = 0; j < arr.length; j++) {
                    let conf = arr[j]
                    let mReward = this.mergeReward(newRewards, conf)
                    if (!mReward) {
                        table.insert(newRewards, conf)
                    }
                }
            }
        } else {
            newRewards = []
            for (let i = 0; i < rewards.length; i++) {
                let arr = this.checkConvert(clone(rewards[i]), skipCheck)
                for (let j = 0; j < arr.length; j++) {
                    let conf = arr[j]
                    let mReward = this.mergeReward(newRewards, conf)
                    if (!mReward) {
                        newRewards.push(conf)
                    }

                }
            }
        }
    } catch (error) {
        cc.error(error)
        window.logCenter && logCenter.error(new Error(error), 'convertRewardError')
        newRewards = rewards
    }
    cc.log("[ConvertReward] convertRewards newRewards", rewards, newRewards, skipCheck)
    return newRewards
}


module.exports = ConvertRewardManager